import { css } from 'glamor'

export default {
  answer: css({
    borderBottom: '1px solid #ccc',
    height: '90px',
    opacity: 1,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',

    '&:first-child': {
      borderTop: '1px solid #ccc',
    },

    '&:hover .circle': {
      backgroundColor: '#D61852',
    },

    '@media(min-width: 400px)': {
      height: '80px',
    },
    '@media(min-width: 550px)': {
      height: '60px',
    },
  }),
  transition: css({
    transition: 'height .2s, opacity .5s',
  }),
  circle: css({
    width: '10px',
    height: '10px',
    border: '2px solid #D61852',
    borderRadius: '50%',
    marginRight: '10px',
    flexShrink: 0,
  }),
  selected: css({
    borderTop: '1px solid #ccc',
    borderBottom: '1px solid #ccc',

    '& .circle': {
      backgroundColor: '#D61852',
    },
  }),
  notSelected: css({
    height: '0',
    border: 'none',
    opacity: 0,
  }),
}



// WEBPACK FOOTER //
// ./src/components/Question/components/Answer/styles.js